import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.module.css';

const ModalHeader = props => (
  <div className={styles.nurtureModalHeader}>
    <span
      data-test="nurture-modal-close"
      role="button"
      tabIndex="0"
      onClick={props.closeBtn}
      onKeyUp={props.closeBtn}
      className={styles.nurtureModalHeaderCloseBtn}
    >
      &times;
    </span>
    {props.children}
  </div>
);

export default ModalHeader;

ModalHeader.propTypes = {
  closeBtn: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};
